var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"user-login","fluid":"","tag":"section"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('h1',[_vm._v(" Logging out ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }